// =======================
// AC SERVICE (UPDATED)
// =======================
// • Base fee: 50 tk
// • First unit uses `first`; each additional unit uses `additional`
export const AC_PRICING = {
  base: 50, // base fee (tk)
  platformFee: { percent: 0.05, min: 50 }, // New

  perUnit: {
    // installation_outdoor_inside:  { first: 1200, additional: 1100 },
    // installation_outdoor_outside: { first: 1500, additional: 1400 },
    installation_outdoor_inside:  { first: 1500, additional: 1400 }, // UPDATED
    installation_outdoor_outside: { first: 2000, additional: 1900 }, // UPDATED

    // uninstallation_outdoor_inside:  { first: 800,  additional: 700 },
    // uninstallation_outdoor_outside: { first: 1000, additional: 900 },
    // UPDATED
    uninstallation_outdoor_inside:  { first: 1000, additional: 800 },
    uninstallation_outdoor_outside: { first: 1200, additional: 1000 },

    cleaning_outdoor_inside:  { first: 800,  additional: 600 },
    cleaning_outdoor_outside: { first: 1000, additional: 900 },
  },

  // Set a number here if AC checkup should add a flat fee (e.g., 300).
  // Your last spec didn't define a checkup price, so defaulting to 0.
  // checkupFlat: 500,
    checkup: {
        base: 500,          // total for up to `includesUnits`
        includesUnits: 2,   // 1–2 covered by base
        extraPerUnit: 200,  // per AC beyond 2
    },
};

// =======================
// ELECTRICIAN
// =======================
// Matches your previous per-item rates. All are simple per-unit adds.
// Example usage: price += stateVar * ELECTRICIAN_PRICING.perUnit.fanInstall;
export const ELECTRICIAN_PRICING = {
  base: 50,
  platformFee: { percent: 0.05, min: 50 }, // NEW
  perUnit: {
    new_ceiling_fan_installation: 200,
    ceiling_fan_installation: 150,
    ceiling_fan_uninstallation: 100,
    fan_coil_new_winding: 1200,
    fan_coil_repair: 800,
    capacitor_setup: 150,

    light_installation: 150,
    light_repair: 150,

    exhaust_fan_installation: 150,
    exhaust_fan_cleaning: 150,

    switch_setup: 150,
    socket_setup: 150,
    regulator_setup: 150,

    new_wiring_point: 300,
    main_circuit_board_setup: 200,

    doorbell_installation: 150,
    // drill_hole_service: 20,
    drill_hole_service: { first: 120, additional: 20 }, 

    ips_installation_existing_line: 500,
    ips_new_line_installation: 1000,
  },
  checkupFlat: 150,
};


// =======================
// FILTER
// =======================
export const FILTER_PRICING = {
  base: 50,
  perUnit: {
    newFilterSetup: 500,
    installationFilter: 300,
    uninstallationFilter: 200,
    kitReplacement: 150,
    pipeLeakOrReplace: 120,
    fullServicing: 400,
  },
  checkupFlat: 100, // boolean add-on
};

// =======================
// GAS CHULA
// =======================
export const GAS_CHULA_PRICING = {
  base: 50,
  platformFee: { percent: 0.05, min: 50 },
  perUnit: {
    newChulaSetup: 500,
    chulaSetup: 300,
    burnerSetup: 200,
    burnerCleaning: 150,
    nozzleReplacement: 120,
  },
  checkIssuesFlat: 150, // boolean add-on
};

// =======================
// HOME CLEANING
// =======================
// This service uses some "first unit free" logic on a few fields in your calc.
// We expose the rates and the metadata you need to implement the same math.
// Example usage for an item with {firstFree: true, perAdditional: X}:
//   const c = Math.max(0, bedrooms);
//   price += c > 1 ? (c - 1) * X : 0;
export const HOME_CLEANING_PRICING = {
  base: 50,
  // items where the first unit is free (as per your calc)
  firstFree: {
    bedrooms: { perAdditional: 30 },       // (bedrooms - 1) * 30
    kitchens: { perAdditional: 20 },       // (kitchens - 1) * 20
    drawingdinning: { perAdditional: 40 }, // (drawingdinning - 1) * 40
  },
  // straight per-unit items
  perUnit: {
    bathrooms: 50,
    cloths: 10,
    dishes: 10,
    balconies: 30,
    windowGrills: 40,
    furniture: 60,
    stairsFloors: 40,
    carpets: 50,
  },
};

// =======================
// PLUMBER
// =======================
export const PLUMBER_PRICING = {
  base: 50,
  platformFee: { percent: 0.05, min: 50 }, // NEW
  perUnit: {
    angleValveSetup: 300,
    basinTapSetup: 200,
    magicPipeSetup: 200,
    basinWastePopUpSetup: 500,
    newBasinSetupExistingLines: 700,

    bathroomTapBibCockSetup: 200,
    tissueHolderSetup: 200,
    fillValveReplacement: 200,
    handShowerSetup: 200,
    soapDishSetup: 200,
    bathroomShelfSetup: 300,
    mirrorSetup: 200,
    towelHangerSetup: 200,
    showerHeadSetup: 200,
    concealedStopcockSetup: 500,
    floorDrainNetSetup: 200,

    toiletSeatCoverReplacement: 300,
    toiletSeatCompleteInstallation: 1000,
    highCommodeInstallationExistingLines: 1200,
    blockageClearingHighCommode: 1200,
    blockageClearingLowCommode: 800,

    bathroomDrainLineCleaning: 2500,
    geyserInstallation: 1000,

    kitchenSinkSetupExistingLines: 700,
    sinkBlockageCleaning: 600,
    washingMachinePointSetup: 800,
  },
  issueCheckupFlat: 200, // boolean add-on
};

// Optional: map by service name for convenience
export const SERVICE_PRICING = {
  "AC Service": AC_PRICING,
  Electrician: ELECTRICIAN_PRICING,
  Filter: FILTER_PRICING,
  "Gas Chula": GAS_CHULA_PRICING,
  "Home Cleaning": HOME_CLEANING_PRICING,
  Plumber: PLUMBER_PRICING,
};

export default SERVICE_PRICING;
